<script lang="ts" setup>
import { DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '~/components/ui/dialog'
import { useToast } from '~/components/ui/toast'
import { Button } from '~/components/ui/button'
import { Form, FormField, FormItem, FormControl, FormMessage } from '~/components/ui/form'
import { Input } from '~/components/ui/input'

const { t } = useI18n()
const emit = defineEmits(['next'])
const userStore = useUserStore()
const {toast} = useToast()
const eventBus = useEventBus()

async function onSubmit(values: any, context: any) {
	await userStore.updateJobTokenWallet(values.walletAddress).then(() => {
		toast({
			title: t('Wallet address saved'),
			variant: 'success',
		})
		emit('next')
	}).catch((err) => {
		context.setError('walletAddress', err.message)
	})
}
</script>

<template>
	<div class="p-6 text-white">
		<div class="absolute w-full h-1/2 top-0 left-0 bg-gradient-to-b from-[#00AD6B] to-black z-0"></div>
		<div class="flex justify-center gap-2 mb-6 relative">
			<div v-for="step in 3" class="w-2 h-2 rounded-full" :class="step === 3 ? 'bg-slate-500' : 'bg-gray-200'">
			</div>
		</div>

		<div class="text-center relative">
			<img src="/img/jobtoken/coins-onboarding.png" class="mx-auto mb-6" alt="" />

			<DialogHeader>
				<DialogTitle class="text-3xl font-bold">
					{{ t('Wallet adress') }}
				</DialogTitle>
				<DialogDescription class="text-slate-400 mb-6">
					{{ ('Copy your wallet adress from Tonkeeper app') }}
				</DialogDescription>
			</DialogHeader>

			<Form @submit="onSubmit" class="mb-12" id="wallet-address-form">
				<FormField v-slot="{ componentField }" name="walletAddress">
					<FormItem class="relative">
						<FormControl class="!mt-1">
							<Input class="h-16 bg-transparent rounded-xl border-slate-600" :placeholder="$t('Paste your wallet address')" v-bind="componentField" />
						</FormControl>
						<FormMessage />
					</FormItem>
				</FormField>
			</Form>

			<DialogFooter class="flex flex-col gap-4">
				<DialogClose class="w-full" as-child>
					<Button class="w-full bg-gray-800 hover:bg-gray-900">
						{{ $t('Add later') }}
					</Button>
				</DialogClose>

				<Button type="submit" form="wallet-address-form" variant="primary" class="w-full">
					{{ $t('Save') }}
				</Button>
			</DialogFooter>
		</div>
	</div>
</template>